import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.3799 9.1727'
  const rightTransformOrigin = '38.97 9.1727'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 10.9826H19.98C19.98 10.9826 19.46 5.98266 15.03 3.31266C12.6 1.85266 9.46 0.722664 7.06 1.00266C1.08 1.71266 0 10.9826 0 10.9826Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M0.379883 9.17265C0.379883 9.17265 3.45988 3.45267 5.87988 2.56267C8.29988 1.68267 16.2399 8.5427 18.3799 7.4027C18.3199 4.5427 11.1099 0.132678 6.54988 0.572678C2.15988 1.00268 0.379883 9.17265 0.379883 9.17265Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M48.96 10.9826H28.98C28.98 10.9826 29.5 5.98266 33.93 3.31266C36.36 1.85266 39.5 0.722664 41.9 1.00266C47.89 1.71266 48.96 10.9826 48.96 10.9826Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M48.4038 9.17271C48.4038 9.17271 45.3238 3.45273 42.9038 2.56273C40.4838 1.68273 32.5438 8.54275 30.4038 7.40275C29.8938 4.65275 37.6738 0.132736 42.2338 0.572736C46.6238 1.00274 48.4038 9.17271 48.4038 9.17271Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="9.99011"
            y1="12.7159"
            x2="9.99011"
            y2="3.60786"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="38.9701"
            y1="12.7159"
            x2="38.9701"
            y2="3.60786"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
